import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null;

const ultimoMensajeLeidoSlice = createSlice({
	name: 'ultimoMensajeLeido',
	initialState,
	reducers: {
		setFechaUltimoMensaje: (state, action) => {
			return action.payload;
		}
	}
});

export const { setFechaUltimoMensaje } = ultimoMensajeLeidoSlice.actions;

export default ultimoMensajeLeidoSlice.reducer;
